<template>
    <div class="rectificat">
        <!-- 公共头部 -->
        <CommonHeader :info="headerInfo" :submitUserName="approvalRecordsInfo.taskEventData.firstUserName"></CommonHeader>
        <!-- 基本信息 -->
        <BaseInfoComponent :info="baseInfo"></BaseInfoComponent>
        <!-- 监审重点 -->
        <AdutiPointComponent :info="aduitPointInfo"></AdutiPointComponent>
        <!-- 审计监察附件 -->
        <CommonFiles 
            :info="fileInfo" 
            v-show="fileInfo.files.length > 0" 
            @getFilesData="getFilesData"></CommonFiles>
        <!-- 审批记录 -->
        <CommonApprovalRecords 
            :workFlowGuid="approvalRecordsInfo.businessKey"
            :workFlowFormVar="approvalRecordsInfo.formVar"
            :workFlowFormKey="approvalRecordsInfo.formKey">
        </CommonApprovalRecords>
        <!-- 审批form表单组件 -->
        <CommonForm
            :workFlowGuid="approvalRecordsInfo.businessKey"
            :workFlowFormKey="approvalRecordsInfo.formKey"
            :workFlowFormVar="approvalRecordsInfo.formVar"
            @sendWorkFlow="submitData"
            @taskEvent="taskEvent">
        </CommonForm>
    </div>
</template>
<script>
import {Toast} from 'vant-green'
import CommonHeader from '@/views/audit/components/CommonHeader'
import BaseInfoComponent from '@/views/audit/components/BaseInfoComponent'
import AdutiPointComponent from '@/views/audit/components/AdutiPointComponent.vue'
import CommonFiles from '@/views/audit/components/CommonFiles'
import CommonApprovalRecords from "@/views/audit/components/CommonApprovalRecords"
import CommonForm from '@/views/audit/components/CommonForm'
import {timeStampTransformDate} from '@/utils/approve.js'
import {
    getProjectView,
    getPlanByProjectId,
    getListTeamByPlanGuid,
    getUserInfo,
    selectClueAndPlanAndRisk
} from "@/api/approve.js"
export default {
    components: {
        CommonHeader,
        BaseInfoComponent,
        AdutiPointComponent,
        CommonFiles,
        CommonApprovalRecords,
        CommonForm
    },
    data(){
        return {
            //路由参数
            localPath: {
                projectGuid: ""
            },
            //项目信息
            projectInfo: {},

            //公共头部数据
            headerInfo: {
                dataType: "立项审批",      //标题
                dataName:'',
                dataId:''
            },
            //基本信息
            baseInfo: {
                auditOrgName: "",                  //监审部门
                projectChiefJudgeName: "",         //项目经理
                auditeeOrgName: "",                //被审单位
                annual: "",                        //计划年度
                projectSourceName: "",             //项目来源
                projectTypeName: "",               //项目类型
                projectDegreeName: "",             //项目等级

                businessFiledName: "",             //业务领域
                twoLevelProcessName: "",           //二级流程
                threeLevelProcessName: "",         //三级流程

                projectPmName: "",                 //管理者
                executeDateStr: "",                //执行日期
                auditBackground: "",               //项目背景
                auditObjective: "",                //项目目标
                businessTimeRange: "",             //业务时间范围   timeStart 和timeEnd的拼接
                projectMembers: [],                //项目成员

            },
            //监审重点数据
            aduitPointInfo: {
                assessManDay: "",                  //评估人天数
                claimEndTime: "",                  //要求完成时间
                firstCheckManDay: "",              //初查含方案编制人天
                inspectionManDay: "",              //项目实施监审重点人天
                compileManDay: "",                 //报告编制人天
                auditBasis: "",                    //审计依据
                strategy: "",                      //审计重点策略
                riskList: [],                      //风险点列表
                clueList: [],                      //线索列表

            },
            //公共整改措施附件
            fileInfo: {
                title: "审计监察附件",
                guids: "",
                files: []
            },
            //审批记录相关数据
            approvalRecordsInfo: {
                businessKey: "",   //当前页面guid
                formVar: {
                    degree: 10,
                    transfer: 1,//1走道总 不走直接结束
                },
                formKey: "TBL_PLAN",  //此事项的唯一标识，最好表名，
                taskEventData:{}
            },
        }
    },
    created(){
        document.title = "立项审批";
        let {projectGuid} = this.$route.query;
        this.localPath = {
            ...this.$route.query
        }
        //通过项目guid获取项目信息
        this.getProjectViewEvent(projectGuid);
        // this.getProjectViewEvent("74ce6fc297144244bec5cc0e4875c5a6");
    },
    methods:{

        taskEvent(val){
            this.$set(this.approvalRecordsInfo,'taskEventData',val)
        },
        //通过项目guid获取项目信息
        async getProjectViewEvent(guid){
            try{
                let res = await getProjectView(guid);
                console.log("haahahhaha");
                console.log(res);
                let data = res.data;
                this.projectInfo = data;
                let wfVar = {}
                wfVar.degree = this.projectInfo.degree;
                if (this.projectInfo.degree == 10) {
                    wfVar.transfer = 1;
                } else {
                    wfVar.transfer = 0;
                }
                this.$set(this.approvalRecordsInfo,'formVar',wfVar)
                //填充公共头部信息
                this.fillHeaderData(data);
                //填充基本信息数据
                this.fillBaseInfoData(data);
                //填充监审重点数据
                this.fillAduitPointData(data);
                
            }catch(error){
                // Toast({message: error,size: "small"});
            }
        },
        //填充公共头部信息
        fillHeaderData(data){
            //项目名称
            this.headerInfo.dataName = data.projectName;
            //项目编号
            this.headerInfo.dataId = data.projectId;
        },
        //填充基本信息数据
        async fillBaseInfoData(data){
            this.baseInfo = {
                ...data
            }
            
            //填充项目成员
            try {
                let {projectGuid} = this.localPath;
                // let res = await getPlanByProjectId(projectGuid);
                //通过项目guid找到planId
                let res = await getPlanByProjectId(projectGuid);
                //填充业务时间范围
                this.baseInfo.businessTimeRange = timeStampTransformDate(res.data.timeStart) + "至" + timeStampTransformDate(res.data.timeEnd);
                // let res = await getPlanByProjectId("74ce6fc297144244bec5cc0e4875c5a6");
                if(res.data.workflowguid){
                    //填充审批记录请求guid
                    this.approvalRecordsInfo.businessKey = res.data.workflowguid;
                }
                this.fileInfo.guids = res.data.fileIds;
                //再通过planId找到项目成员
                let data = await getListTeamByPlanGuid(res.data.guid);
                if(data.data.projectHelpLeader){
                    let list = [];
                    let arr = data.data.projectHelpLeader.split(",");
                    for(let i = 0; i < arr.length; i++){
                        let userInfo = await getUserInfo(arr[i]);
                        list.push(userInfo.data.uName);
                    }
                    this.baseInfo.projectMembers = list;
                }
            } catch(error){
                // Toast({message: error,size: "small"});
            }
        },
        //获取附件信息
        getFilesData(data){
            this.fileInfo.files = data;
        },
        //填充监审重点数据
        async fillAduitPointData(data){
            this.aduitPointInfo = {
                ...this.aduitPointInfo,
                ...data
            }
            let {projectGuid} = this.localPath;
            //设置要求完成时间
            this.aduitPointInfo.claimEndTime = timeStampTransformDate(this.aduitPointInfo.claimEndTime);
            //通过项目guid找到风险列表
            let res = await selectClueAndPlanAndRisk(projectGuid);
            //填充风险点列表
            this.aduitPointInfo.riskList = res.data.projectPlanRisks;
            //填充线索列表
            this.aduitPointInfo.clueList = res.data.projectClueList;
        },
        //表单提交审批数据
        submitData(val){
            this.Toast.success('审批成功')
            if(val==1){
                this.$http.get('/api/job/v0.1/project/planApproveComplete?projectGuid=' + this.localPath.projectGuid + '&wfStatus=' + val).then(async (res) => {
                    setTimeout(()=>{
                        location.reload()
                    },500)
                })
            }else{
                setTimeout(()=>{
                    location.reload()
                },500)
            }
        }
        
    }
}
</script>
<style lang="less" scoped>
    .rectificat{
        padding: 15px;
        background-color: #0ea6e0;
        position: relative;
        padding-bottom: 240px;
    }
    
</style>